// extracted by mini-css-extract-plugin
export default {"container":"NumberingView_container__7S9KL","name":"NumberingView_name__YWnb0","section":"NumberingView_section__V8DwS"};